<template>
    <div class="">

        <b-form @submit.stop.prevent="onSubmit">

            <div class="clearfix row mb-2">
                <div class="col-sm-6 float-left " v-if="use_signature_pad">
                    <VueSignaturePad height="150px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" style="background: #eee;"/>
                </div>
                <div class="col-sm-6 float-left " v-else>
                    <b-form-group id="signature_file-group" label="Upload Signature" label-for="signature_file" v-if="use_signature_pad == false">
                        <b-form-file id="signature_file" v-model="signature_file" @change="checkFileType($event, 'signature_file', ['.jpg', '.png', '.gif', '.pdf', '.doc' , '.docx'])" accept=".jpg, .png, .gif, .pdf , .doc , .docx"  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." ></b-form-file>
                    </b-form-group>
                </div>

                <div class="col-sm-6 float-right "><img v-if="signature_url != null" :src="signature_url" /></div>

            </div>

            <b-form-group id="use_signature_pad-group" label-for="use_signature_pad" >
                <b-form-checkbox id="use_signature_pad" v-model="use_signature_pad" name="use_signature_pad">
                    Use Signature Pad
                </b-form-checkbox>
            </b-form-group>

            <!-- alpha fix- added class ml-2 btn-primary custom-wizard-btn to btn and text-center  -->
            <b-form-group id="submit-group" class="mt-4 text-center">
                <b-button type="submit" variant="primary">Save</b-button>
                <b-button class="ml-2 btn-primary custom-wizard-btn" @click="undoSignaturePad">Reset</b-button>
            </b-form-group>
        </b-form>


    </div>
</template>

<script>
    import Vue from 'vue';
    import VueSignaturePad from 'vue-signature-pad';
    Vue.use(VueSignaturePad);

    export default{


        mounted() {
            //console.log('Bank info started..');
            //console.log(this.employee_id);
        },
        data(){

            return {

                singature : null,
                signature_url : null,

                use_signature_pad : true,

                signature_file : null,

            }
        },
        methods:{
            undoSignaturePad() {
              this.$refs.signaturePad.clearSignature();
              this.signature_file = null;
            },
            saveSignaturePad() {
              this.singature = this.$refs.signaturePad.saveSignature();
            },
            getSignature: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/employee/singature').then(function(response){
                    this.signature_url = response.data;
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;

                //this.$refs.signaturePad.saveSignature();


                //this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if(this.signature_file && !this.use_signature_pad)
                {
                    formData.append('upload_file', this.signature_file);
                }
                else
                {
                    const { isEmpty, data } = currentObj.$refs.signaturePad.saveSignature();
                    if(!isEmpty)
                        formData.append('signature_pad', data);
                    else
                        return;
                }

                axios.post(this.$api_url+'/employee/singature/save', formData, config)
                    .then(function (response)
                    {


                        this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        this.signature_url = response.data;

                        this.$emit('childToParent');

                        //setTimeout(function () {location.reload();  }.bind(this), 1000);

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.showoverlay_list = false;
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });

            },




        },
        created: function(){
            this.getSignature();

        },
    }
</script>
